import { render, staticRenderFns } from "./taBtnNewCode.vue?vue&type=template&id=d47baeb4&scoped=true&"
import script from "./taBtnNewCode.vue?vue&type=script&lang=js&"
export * from "./taBtnNewCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47baeb4",
  null
  
)

export default component.exports